"use client";
import React, { memo } from "react";
import { SessionProvider } from "next-auth/react";

const DowndorProvider = memo(({ children, ...otherProps }) => (
  <SessionProvider
    refetchInterval={0}
    refetchOnWindowFocus={false}
    {...otherProps}
  >
    {children}
  </SessionProvider>
), (oldProps, newProps) => {
  return (JSON.stringify(oldProps.session) === JSON.stringify(newProps.session));
});

DowndorProvider.displayName = "DowndorProvider";

export default DowndorProvider;